export default __webpack_public_path__ + "static/media/spinner.064dcfe5.png";